import { useState } from 'react';
import DataTable from '../../components/DataTable';
import Modal from '../../components/Modal';
import { useApi } from '../../hooks/useApi';
import logger from "../../utils/logger";
const emptyForm = {
  name: '',
  phone: '',
  email: '',
  website: '',
  inn: '',
  address: ''
};
function CompaniesTable({
  companies,
  onCompaniesChange
}) {
  const {
    request,
    showStatus
  } = useApi();
  const [modalOpen, setModalOpen] = useState(false);
  const [activeCompany, setActiveCompany] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const openCreate = () => {
    setActiveCompany(null);
    setForm(emptyForm);
    setModalOpen(true);
  };
  const openEdit = company => {
    setActiveCompany(company);
    setForm({
      name: company.name || '',
      phone: company.phone || '',
      email: company.email || '',
      website: company.website || '',
      inn: company.inn || '',
      address: company.address || ''
    });
    setModalOpen(true);
  };
  const handleSave = async event => {
    event.preventDefault();
    if (!form.name.trim()) return;
    try {
      if (activeCompany) {
        const updated = await request(`/api/v1/crm/companies/${activeCompany.id}`, {
          method: 'PATCH',
          body: JSON.stringify(form)
        });
        onCompaniesChange(companies.map(item => item.id === updated.id ? updated : item));
        showStatus('success', 'Компания обновлена.');
      } else {
        const created = await request('/api/v1/crm/companies', {
          method: 'POST',
          body: JSON.stringify(form)
        });
        onCompaniesChange([created, ...companies]);
        showStatus('success', 'Компания добавлена.');
      }
      setModalOpen(false);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось сохранить компанию.');
    }
  };
  const handleDelete = async () => {
    if (!activeCompany || !window.confirm(`Удалить компанию «${activeCompany.name || activeCompany.full_name || ''}»?`)) return;
    try {
      await request(`/api/v1/crm/companies/${activeCompany.id}`, { method: 'DELETE' });
      onCompaniesChange(companies.filter(item => item.id !== activeCompany.id));
      showStatus('success', 'Компания удалена.');
      setModalOpen(false);
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось удалить: ' + (error?.message || ''));
    }
  };
  const columns = [{
    key: 'name',
    label: 'Компания'
  }, {
    key: 'phone',
    label: 'Телефон',
    render: row => row.phone || '—'
  }, {
    key: 'email',
    label: 'Email',
    render: row => row.email || '—'
  }, {
    key: 'inn',
    label: 'ИНН',
    render: row => row.inn || '—'
  }, {
    key: 'website',
    label: 'Сайт',
    render: row => row.website || '—'
  }];
  return <div className="crm__block">
            <div className="crm__toolbar">
                <div className="crm__toolbar-left">
                    <h4>Компании</h4>
                </div>
                <button type="button" onClick={openCreate}>
                    Добавить компанию
                </button>
            </div>

            <DataTable className="crm__table" headerClassName="crm__row crm__row--head crm__row--companies" rowClassName="crm__row crm__row--clickable crm__row--companies" columns={columns} rows={companies} getRowKey={row => row.id} onRowClick={openEdit} />
      

            <Modal open={modalOpen} onClose={() => setModalOpen(false)} title="Компания">
                <form className="panel__form" onSubmit={handleSave}>
                    <label>
                        Название
                        <input type="text" value={form.name} onChange={event => setForm({
            ...form,
            name: event.target.value
          })} required />
            
                    </label>
                    <div className="panel__grid">
                        <label>
                            Телефон
                            <input type="text" value={form.phone} onChange={event => setForm({
              ...form,
              phone: event.target.value
            })} />
              
                        </label>
                        <label>
                            Email
                            <input type="email" value={form.email} onChange={event => setForm({
              ...form,
              email: event.target.value
            })} />
              
                        </label>
                    </div>
                    <div className="panel__grid">
                        <label>
                            Сайт
                            <input type="text" value={form.website} onChange={event => setForm({
              ...form,
              website: event.target.value
            })} />
              
                        </label>
                        <label>
                            ИНН
                            <input type="text" value={form.inn} onChange={event => setForm({
              ...form,
              inn: event.target.value
            })} />
              
                        </label>
                    </div>
                    <label>
                        Адрес
                        <input type="text" value={form.address} onChange={event => setForm({
            ...form,
            address: event.target.value
          })} />
            
                    </label>
                    <div className="panel__actions">
                        {activeCompany && (
                            <button type="button" className="ghost danger" onClick={handleDelete}>
                                Удалить
                            </button>
                        )}
                        <button type="button" className="ghost" onClick={() => setModalOpen(false)}>
                            Отмена
                        </button>
                        <button type="submit">Сохранить</button>
                    </div>
                </form>
            </Modal>
        </div>;
}
export default CompaniesTable;
